import { newReleases } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

export default function NewReleases() {
  return (
    <section id="new" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="最新片单"
          title="近几年值得关注的韩影新作"
          desc="院线与影展陆续带来的新片里，这几部在口碑与讨论度上都表现突出，题材也延续了韩国电影对人性与关系的持续关注。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {newReleases.map((film) => (
            <article
              key={film.title}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={film.image}
                  alt={`《${film.title}》影片氛围示意`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-label text-accent-800">
                    {film.year}
                  </span>
                  <span className="text-xs font-label text-foreground-500">
                    {film.genre}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  {film.title}
                </h3>
                <p className="mt-0.5 text-xs font-label text-foreground-500">
                  {film.original} · {film.director}
                </p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {film.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}